// extracted by mini-css-extract-plugin
module.exports = {"mobileTableCard":"MobileTableRow_mobileTableCard__oHyVV","bodyDefault":"MobileTableRow_bodyDefault__J5eZF","shareSelector":"MobileTableRow_shareSelector__uAOXN"};